import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { API_URL } from '@/config';

export type RegisterCredentialsDTO = {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
  google_access_token?: string;
  auth_type?: string;
  github_oauth_code?: string;
  redirect_url?: string;
  username?: string;
};

export const register = async (data: RegisterCredentialsDTO): Promise<any> => {
  const response = await axios.post(`${API_URL}/v2/auth/create`, {
    username: data.username,
    email: data.email,
    password: data.password,
    first_name: data.firstName,
    last_name: data.lastName,
    google_access_token: data.google_access_token,
    auth_type: data.auth_type || 'email',
    github_oauth_code: data.github_oauth_code,
    redirect_url: data.redirect_url,
  });
  return response.data;
};

export const useRegister = (config = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation<any, Error, RegisterCredentialsDTO>({
    mutationFn: register,
    onError: (error) => {
      addNotification({
        type: 'error',
        title: 'Sign up failed',
        message: error.message,
      });
    },
    onSuccess: (data) => {
      if (data) {
        addNotification({
          type: 'success',
          title: 'Sign up successful',
          message:
            data?.message ||
            'You have successfully registered. Please check your email to verify your account.',
          delay: 6000,
        });
        window.location.assign(data?.redirect_url || `${window.location.origin}/auth/login`);
      }
    },
    ...config,
  });
};
